var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 18.3333H5.83337C5.49171 18.3333 5.20837 18.05 5.20837 17.7083C5.20837 17.3666 5.49171 17.0833 5.83337 17.0833H14.1667C14.5084 17.0833 14.7917 17.3666 14.7917 17.7083C14.7917 18.05 14.5084 18.3333 14.1667 18.3333Z",
    fill: "#FBB051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9584 4.60001L13.6251 6.98335C13.1834 7.30001 12.5501 7.10835 12.3584 6.60001L10.7834 2.40001C10.5167 1.67501 9.49173 1.67501 9.22506 2.40001L7.64173 6.59168C7.45006 7.10835 6.82506 7.30001 6.38339 6.97501L3.05006 4.59168C2.38339 4.12501 1.50006 4.78335 1.77506 5.55835L5.24173 15.2667C5.35839 15.6 5.67506 15.8167 6.02506 15.8167H13.9667C14.3167 15.8167 14.6334 15.5917 14.7501 15.2667L18.2167 5.55835C18.5001 4.78335 17.6167 4.12501 16.9584 4.60001ZM12.0834 12.2917H7.91673C7.57506 12.2917 7.29173 12.0083 7.29173 11.6667C7.29173 11.325 7.57506 11.0417 7.91673 11.0417H12.0834C12.4251 11.0417 12.7084 11.325 12.7084 11.6667C12.7084 12.0083 12.4251 12.2917 12.0834 12.2917Z",
    fill: "#FBB051"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.21d1fd8d07ec70f82e5f16065abe439b.svg";
export { ForwardRef as ReactComponent };